import { FC } from 'react';
import { Drawer } from 'antd';
import styled from 'styled-components';

import { DocumentCategory } from '@/shared/lib/sj-orm/models/document/personal-identifier.document.dto';

import { PidCategoryList } from './PidCategoryList';

type SelectPidCategoryProps = {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (category: DocumentCategory) => void;
};
// TODO remove, use SelectPidTypeModal
export const SelectPidCategory: FC<SelectPidCategoryProps> = ({ isOpen, onClose, onSelect }) => {
  return (
    <StyledDrawer
      height={'80vh'}
      placement="bottom"
      closable={false}
      onClose={onClose}
      open={isOpen}
    >
      <PidCategoryList onSelect={onSelect} />
    </StyledDrawer>
  );
};

const StyledDrawer = styled(Drawer)`
  &&& {
    .ant-drawer-body {
      padding: 0;
    }
  }
`;
